import RequestAbstract from "./RequestAbstract";

// Personal API tokens for AI assistants (Claude, Codex) — see server docs/api-tokens.md.
export default class ApiTokens extends RequestAbstract {
  get link() {
    return "api-tokens";
  }

  async list() {
    return await this.get(this.link);
  }

  async create({ name, abilities, days }) {
    return await this.post(this.link + "/create", {
      name,
      abilities,
      expires_in_days: days,
    });
  }

  async revoke(id) {
    return await this.post(this.link + "/revoke/" + id, {});
  }
}
